export const ASSET_PERKS_SUCCESS = 'ASSET_PERKS_SUCCESS';
export const ASSET_PERKS_ALL_SUCCESS = 'ASSET_PERKS_ALL_SUCCESS';
export const ASSET_PERKS_ERROR = 'ASSET_PERKS_ERROR';
export const ASSET_PERKS_LOADING = 'ASSET_PERKS_LOADING';
export const ASSET_PERKS_FETCHING = 'ASSET_PERKS_FETCHING';
export const ASSET_PERKS_ATTRIBUTION_STATUS_UPDATE = 'ASSET_PERKS_ATTRIBUTION_STATUS_UPDATE';
export const TEST = "TEST"